import {
  getStandardWatermarkAttributes,
  getWatermarkConfig
} from '@/components/Chart/hooks/options/useChartFunctions';

import type { FullscreenWatermarkChart, FullscreenWatermarkKey } from './fullScreenChartTypes';

const DARK_MODE_WATERMARK = getWatermarkConfig('/watermark-black.svg');
const LIGHT_MODE_WATERMARK = getWatermarkConfig('/watermark-color.svg');

const createWatermarkImage = (chart: FullscreenWatermarkChart, key: FullscreenWatermarkKey) => {
  const watermark = key === 'darkMode' ? DARK_MODE_WATERMARK : LIGHT_MODE_WATERMARK;
  return chart.renderer
    .image(watermark.dataUri)
    .addClass(`gx-fullscreen-watermark gx-fullscreen-watermark-${key}`)
    .add();
};

export const applyFullscreenWatermarkLayout = (
  chart: FullscreenWatermarkChart,
  useSmallWatermark = false
): void => {
  const watermarks = (chart.fullscreenWatermarks ??= {});
  watermarks.darkMode ??= createWatermarkImage(chart, 'darkMode');
  watermarks.lightMode ??= createWatermarkImage(chart, 'lightMode');

  const attrs = getStandardWatermarkAttributes({
    chart,
    aspectRatio: DARK_MODE_WATERMARK.aspectRatio,
    useSmallWatermark
  });

  [watermarks.darkMode, watermarks.lightMode].forEach(image => {
    image.attr({ height: attrs.height, width: attrs.width, zIndex: attrs.zIndex });
    image.align(
      {
        align: attrs.align ?? 'right',
        verticalAlign: attrs.verticalAlign ?? 'bottom',
        x: attrs.x,
        y: attrs.y
      },
      false,
      'plotBox'
    );
  });
};
